import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/city-clerk/projects')({
  component: CityClerkProjectsPage,
})

function CityClerkProjectsPage() {
  return <div>City Clerk Projects Page</div>
}
